export enum TypeKeys {
    SHOW_NOTIFICATION = 'notification/SHOW_NOTIFICATION',
    CLEAR_NOTIFICATION = 'notification/CLEAR_NOTIFICATION'
}

export interface NotificationState {
    notificationText: string | null;
    notificationSubText: string | null;
}

export type ShowNotification = {
    type: TypeKeys.SHOW_NOTIFICATION;
    text: string;
    subText: string;
}

export type ClearNotification = {
    type: TypeKeys.CLEAR_NOTIFICATION;
}